const toggleFn = (event) => {
	const targetElement = event.target;
	const parentElement = targetElement.closest('.kg-toggle-card');
	var toggleState = parentElement.getAttribute("data-kg-toggle-state");
	if (toggleState === 'close') {
		parentElement.setAttribute('data-kg-toggle-state', 'open');
	} else {
		parentElement.setAttribute('data-kg-toggle-state', 'close');
	}
};

export default toggleFn;
